import { useScrollReveal } from "@/hooks/useScrollReveal";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import StatsBar from "./components/StatsBar";
import AboutUs from "./components/AboutUs";
import ProblemSolution from "./components/ProblemSolution";
import Services from "./components/Services";
import Process from "./components/Process";
import WhyUs from "./components/WhyUs";
import Testimonials from "./components/Testimonials";
import Brands from "./components/Brands";
import UrgencyBanner from "./components/UrgencyBanner";
import QuoteForm from "./components/QuoteForm";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

export default function Home() {
  useScrollReveal();

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <AboutUs />
        <ProblemSolution />
        <Services />
        <Process />
        <WhyUs />
        <Testimonials />
        <Brands />
        <UrgencyBanner />
        <QuoteForm />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}